import React, { useState, useEffect } from 'react';
import useDebounce from 'hooks/useDebounce';
import { Input } from 'antd';
import { useTranslation } from 'react-i18next';
import { Icon, IconName } from 'components/Icon/Icon';
import classNames from 'classnames';
import style from './SearchFieldNew.module.scss';

type TDelay = 0 | 800;

interface IProps {
	onChangeSelectSearchString: (value: string) => void;
	searchString: string;
	className?: string;
	delay?: TDelay;
	size?: 'medium' | 'large';
}

export const SearchFieldNew: React.FC<IProps> = React.memo(
	({ onChangeSelectSearchString, searchString, className, delay = 0, size = 'medium' }) => {
		const [searchTerm, setSearchTerm] = useState('');
		const debouncedSearchTerm = useDebounce(searchTerm, delay);
		const { t } = useTranslation('global');

		const containerClasses = classNames(style.container, className, {
			[style.sizeLarge]: size === 'large',
		});

		const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
			setSearchTerm(e.target.value);
		};

		const handleKeyDown = (e: React.KeyboardEvent<HTMLInputElement>) => {
			e.stopPropagation();
		};

		useEffect(() => {
			onChangeSelectSearchString(debouncedSearchTerm);
		}, [debouncedSearchTerm]);

		useEffect(() => {
			setSearchTerm(searchString);
		}, [searchString]);

		return (
			<Input
				className={containerClasses}
				onChange={handleChange}
				value={searchTerm}
				onKeyDown={handleKeyDown} // To fix cleanup dishes multiple select when press backspace
				allowClear={true}
				placeholder={t('searchPlaceholder')}
				prefix={<Icon name={IconName.search} size="lg" className={style.searchIcon} />}
				data-test="SearchField"
			/>
		);
	},
);
